<template>
  <div class="login-page" @click.self="goHome">
    <div class="login-box">
      
      <!-- Tab 切换 -->
      <div class="tab-wrap">
        <div class="tab-item" :class="{active: tab === 'login'}" @click="tab='login'">密码登录</div>
        <div class="tab-item" :class="{active: tab === 'register'}" @click="tab='register'">新用户注册</div>
      </div>

      <!-- ========== 登录表单 ========== -->
      <div v-if="tab === 'login'" class="form-anim">
        <div class="form-row">
          <div class="form-item">
            <label>手机号</label>
            <input v-model="loginForm.phone" type="tel" maxlength="11" placeholder="请输入手机号">
          </div>
          <div class="form-item">
            <label>登录密码</label>
            <input v-model="loginForm.pwd" type="password" placeholder="请输入密码">
          </div>
        </div>
        
        <div class="forgot-row">
          <span class="forgot-link" @click="openResetModal">忘记密码？</span>
        </div>
        
        <button class="submit-btn" @click="handleLogin">登 录</button>
      </div>

      <!-- ========== 注册表单 ========== -->
      <div v-if="tab === 'register'" class="form-anim">
        <div class="form-row">
          <div class="form-item">
            <label>手机号</label>
            <input v-model="regForm.phone" type="tel" maxlength="11" placeholder="请输入手机号">
          </div>
          <div class="form-item">
            <label>设置密码</label>
            <input v-model="regForm.pwd" type="password" placeholder="8位以上，包含字母">
          </div>
        </div>
        
        <div class="form-item">
          <label>短信验证码</label>
          <div class="code-input-group">
            <input v-model="regForm.smsCode" placeholder="输入6位验证码">
            <button class="get-code-btn" @click="triggerSlider('register')" :disabled="countdown > 0">
              {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
            </button>
          </div>
        </div>
        
        <div class="agree-row">
          <label class="custom-checkbox">
            <input type="checkbox" v-model="regForm.agreeTerms">
            <span class="checkmark"></span>
            <span class="agree-text">
              已阅读并同意 <a @click.stop.prevent="goAgreement">《用户协议》</a> 和 <a @click.stop.prevent="goPrivacy">《隐私政策》</a>
            </span>
          </label>
        </div>
        
        <button class="submit-btn" style="margin-top: 16px;" @click="handleRegister">注 册</button>
      </div>
    </div>

    <!-- ========== 重置密码弹窗 ========== -->
    <div v-if="showResetModal" class="modal-mask" @click.self="closeResetModal">
      <div class="reset-modal">
        <h3>重置密码</h3>
        
        <div class="form-row">
          <div class="form-item">
            <label>注册手机号</label>
            <input v-model="resetForm.phone" type="tel" maxlength="11" placeholder="请输入手机号">
          </div>
          <div class="form-item">
            <label>新密码</label>
            <input v-model="resetForm.newPwd" type="password" placeholder="8位以上，包含字母">
          </div>
        </div>

        <div class="form-item">
          <label>短信验证码</label>
          <div class="code-input-group">
            <input v-model="resetForm.smsCode" placeholder="请输入6位验证码">
            <button class="get-code-btn" @click="triggerSlider('reset')" :disabled="countdown > 0">
              {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
            </button>
          </div>
        </div>
        
        <div class="btn-group">
          <button class="cancel-btn" @click="closeResetModal">取消</button>
          <button class="confirm-btn" @click="handleResetPwd">确认重置</button>
        </div>
      </div>
    </div>

    <!-- ========== 滑块验证弹窗 ========== -->
    <div v-if="showSliderModal" class="modal-mask" @click.self="closeSlider">
      <div class="slider-box">
        <h4>解除封印</h4>
        <p>开启珍藏回忆 & 封存爱的印记</p>
        
        <div class="slider-track" ref="sliderTrack" :class="{ 'is-success': sliderX >= maxSlide }">
          <div class="slider-bg-text">向右滑动 解除封印</div>
          <div class="slider-fill" :style="{ width: sliderX + 'px' }"></div>
        <div 
          class="slider-btn" 
          :style="{ left: sliderX + 'px' }"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <!-- 👇 直接引用你的 seal.webp，并让它填满按钮 -->
          <img 
            src="@/assets/seal.webp" 
            alt="拖动验证" 
            style="width: 100%; height: 100%; object-fit: contain;" 
          />
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: "Login",
  data() {
    return {
      tab: "login",
      loginForm: { phone: "", pwd: "" },
      regForm: { phone: "", pwd: "", smsCode: "", agreeTerms: false },
      resetForm: { phone: "", smsCode: "", newPwd: "" },
      
      showResetModal: false,
      countdown: 0,
      
      // 滑块相关
      showSliderModal: false,
      sliderAction: "", 
      sliderX: 0,
      isDragging: false,
      startX: 0,
      maxSlide: 240,
    }
  },
  methods: {
    goHome() { 
      this.$router.push("/"); 
    },
    triggerSlider(action) {
      let phone = "";
      if (action === 'register') phone = this.regForm.phone;
      else if (action === 'reset') phone = this.resetForm.phone;
      else if (action === 'login') {
        phone = this.loginForm.phone;
        if (!this.loginForm.pwd) return alert("请填写密码");
      }

      if (action !== 'login' && (!phone || !/^1\d{10}$/.test(phone))) {
        return alert("请先输入正确的 11 位手机号");
      }
      if (action === 'reset') {
        if (!this.resetForm.newPwd) return alert("请先填写新密码");
        if (!/^(?=.*[A-Za-z]).{8,}$/.test(this.resetForm.newPwd)) {
          return alert("新密码必须8位以上，包含字母");
        }
      }
      if (action === 'register') {
        if (!this.regForm.pwd) return alert("请先设置密码");
        if (!/^(?=.*[A-Za-z]).{8,}$/.test(this.regForm.pwd)) {
          return alert("密码必须8位以上，包含字母");
        }
      }
      this.sliderAction = action;
      this.sliderX = 0;
      this.showSliderModal = true;
    },
    closeSlider() {
      this.showSliderModal = false;
      this.sliderX = 0;
      this.isDragging = false;
    },
    startDrag(e) {
      this.isDragging = true;
      const track = this.$refs.sliderTrack;
      const btn = track.querySelector('.slider-btn');
      this.maxSlide = track.clientWidth - btn.offsetWidth - 2;

      this.startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      
      const onMove = (ev) => {
        if (!this.isDragging) return;
        if (ev.type.includes('touch')) ev.preventDefault(); 
        
        const currentX = ev.type.includes('mouse') ? ev.clientX : ev.touches[0].clientX;
        let moveX = currentX - this.startX;
        
        if (moveX < 0) moveX = 0;
        if (moveX > this.maxSlide) moveX = this.maxSlide;
        
        this.sliderX = moveX;
        
        if (this.sliderX >= this.maxSlide) {
          this.isDragging = false;
          this.sliderSuccess();
        }
      };

      const onEnd = () => {
        this.isDragging = false;
        if (this.sliderX < this.maxSlide) {
          this.sliderX = 0; 
        }
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onEnd);
    },

    async sliderSuccess() {
      setTimeout(() => {
        this.showSliderModal = false;
      }, 400); 

      if (this.sliderAction === 'login') {
        try {
          const { phone, pwd } = this.loginForm;
          const res = await request.post('/auth/login', { phone, pwd });
          if (!res.success) return alert(res.msg);
          this.loginSuccess(res.token);
        } catch (err) {
          const errorMsg = (err.response && err.response.data && err.response.data.msg) 
                        || (err.data && err.data.msg) 
                        || (err.message) 
                        || "登录失败，请检查网络";
          alert(errorMsg);
        }
        return; 
      }

      const phone = this.sliderAction === 'register' ? this.regForm.phone : this.resetForm.phone;
      
      try {
        const res = await request.post('/auth/send-sms', { phone, type: this.sliderAction });
        if (res.success) {
          this.$showToast("验证码已发送，请注意查收短信", "success");
          this.startCountdown();
        } else {
          alert(res.msg);
        }
      } catch (err) {
        console.error(err);
        const errorMsg = (err.response && err.response.data && err.response.data.msg) 
                      || (err.data && err.data.msg) 
                      || (err.message) 
                      || "发送失败，请检查网络";
        alert(errorMsg);
      }
    },

    startCountdown() {
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) clearInterval(timer);
      }, 1000);
    },

    handleLogin() {
      const { phone, pwd } = this.loginForm;
      if (!phone || !pwd) return alert("请填写手机号和密码");
      this.triggerSlider('login');
    },
    async handleRegister() {
      const { phone, pwd, smsCode, agreeTerms } = this.regForm;
      if (!phone || !pwd || !smsCode) return alert("请填写完整信息");
      if (!agreeTerms) return alert("请先阅读并同意协议");
      if (!/^(?=.*[A-Za-z]).{8,}$/.test(pwd)) return alert("密码必须8位以上，包含字母");
      
      try {
        const res = await request.post('/auth/register', { 
          phone, 
          pwd, 
          captcha: smsCode 
        });
        
        if (!res.success) return alert(res.msg);
        this.loginSuccess(res.token);
      } catch (err) {
        const errorMsg = (err.response && err.response.data && err.response.data.msg) 
                      || (err.data && err.data.msg) 
                      || (err.message) 
                      || "注册失败，请检查网络";
        alert(errorMsg);
      }
    },

    async handleResetPwd() {
      const { phone, smsCode, newPwd } = this.resetForm;
      if (!phone || !smsCode || !newPwd) return alert("请填写完整");
      if (!/^(?=.*[A-Za-z]).{8,}$/.test(newPwd)) return alert("密码必须8位以上，包含字母");

      try {
        const res = await request.post('/auth/reset-pwd', { phone, code: smsCode, newPwd });
        if (!res.success) return alert(res.msg);
        alert("密码重置成功，请登录");
        this.closeResetModal();
        this.tab = 'login';
      } catch (err) {
        const errorMsg = (err.response && err.response.data && err.response.data.msg) 
                      || (err.data && err.data.msg) 
                      || (err.message) 
                      || "重置失败，请检查网络";
        alert(errorMsg);
      }
    },

    openResetModal() {
      this.resetForm = { phone: this.loginForm.phone, smsCode: "", newPwd: "" };
      this.showResetModal = true;
    },
    closeResetModal() {
      this.showResetModal = false;
    },

    async loginSuccess(token) {
      localStorage.setItem('token', token);
      try {
        const res = await request.get('/user/current');
        if (res.success) {
          localStorage.setItem("currentUser", JSON.stringify({
            phone: res.user.phone,
            groupIdList: res.user.groupIdList || [],
            currentGroupId: res.user.currentGroupId || 'personal',
            groupType: res.user.groupType || 'personal'
          }));
          localStorage.setItem("user", JSON.stringify({
            nickname: res.user.nickname,
            signature: res.user.signature,
            avatar: res.user.avatar || '/default-avatar.webp'
          }));
        }
      } catch (err) {}

      // 🔥 1. 动态创建原生 DOM 播放动画，无视 Vue 的销毁！
      const animContainer = document.createElement('div');
      animContainer.id = 'native-seal-anim';
      // 把动画容器挂载到 body 上，不管路由怎么跳，它都在最上层
      animContainer.style.cssText = `
        position: fixed; inset: 0; z-index: 9999999;
        background: radial-gradient(circle at center, #1a1512 0%, #050505 100%);
        display: flex; justify-content: center; align-items: center;
        overflow: hidden; opacity: 1;
        animation: nativeBgReveal 1.2s ease-in 1.6s forwards;
      `;

      // 动态创建图片
      const sealImg = document.createElement('img');
      sealImg.src = require('@/assets/seal.webp'); // 绝对安全的本地路径获取
      sealImg.style.cssText = `
        height: 35vh; max-height: 250px; width: auto; object-fit: contain; opacity: 0;
        animation: nativeWakeAndBreakthrough 2.8s cubic-bezier(0.8, 0, 0.2, 1) forwards;
      `;

      animContainer.appendChild(sealImg);
      document.body.appendChild(animContainer);

      // 🔥 2. 注入原生 CSS 关键帧
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes nativeWakeAndBreakthrough {
          0% { opacity: 0; filter: blur(10px) brightness(0.5); transform: scale(0.8); }
          15% { opacity: 1; filter: blur(0) brightness(1); transform: scale(1) translateX(0) rotate(0deg); }
          25% { opacity: 1; filter: blur(0) brightness(1); transform: scale(1) translateX(0) rotate(0deg); }
          30% { transform: scale(1.01) translateX(-2px) rotate(-0.2deg); filter: drop-shadow(0 0 20px rgba(255, 200, 0, 0.4)) brightness(1.1); }
          36% { transform: scale(1.02) translateX(2px) rotate(0.2deg); filter: drop-shadow(0 0 25px rgba(255, 200, 0, 0.5)) brightness(1.2); }
          42% { transform: scale(1.03) translateX(-4px) rotate(-0.5deg); filter: drop-shadow(0 0 35px rgba(255, 200, 0, 0.6)) brightness(1.3); }
          48% { transform: scale(1.04) translateX(4px) rotate(0.5deg); filter: drop-shadow(0 0 45px rgba(255, 200, 0, 0.7)) brightness(1.5); }
          54% { transform: scale(1.05) translateX(-6px) rotate(-0.8deg); filter: drop-shadow(0 0 60px rgba(255, 200, 0, 0.9)) brightness(1.7); }
          60% { transform: scale(1.06) translateX(6px) rotate(0.8deg); filter: drop-shadow(0 0 70px rgba(255, 200, 0, 1)) brightness(1.9); }
          64% { transform: scale(1.08) translateX(-3px) rotate(-0.3deg); filter: drop-shadow(0 0 80px rgba(255, 200, 0, 1)) brightness(2.0); }
          
          65% { transform: scale(1.1) translateX(0) rotate(0deg); filter: drop-shadow(0 0 80px rgba(255, 200, 0, 1)) brightness(2.2); opacity: 1; }
          
          /* 👇 核心修改：从 65% 到 100%，不再让它透明，而是疯狂放大并保持高亮！ */
          100% { opacity: 1; transform: scale(150); filter: drop-shadow(0 0 100px rgba(255, 255, 255, 1)) brightness(4); }
        }        @keyframes nativeBgReveal {
          0% { background: radial-gradient(circle at center, #1a1512 0%, #050505 100%); }
          65% { background: #1a1512; } /* 配合抖动结束，背景才开始变白 */
          100% { background: #ffffff; }
        }
      `;
      document.head.appendChild(style);
      // 🔥 3. 2.8 秒后，路由跳转 + 铺白布 + 移除动画
      setTimeout(() => {
        // 插白布
        const whiteMask = document.createElement('div');
        whiteMask.style.cssText = `
          position: fixed; inset: 0; background: #ffffff; z-index: 99999999;
          opacity: 1; pointer-events: none; transition: opacity 0.8s ease-in-out;
        `;
        document.body.appendChild(whiteMask);

        // 跳转（此时路由爱怎么跳怎么跳，反正全屏被白布盖着）
        this.$router.push("/").catch(() => {});
        
        // 彻底清空动画 DOM
        if (document.body.contains(animContainer)) {
          document.body.removeChild(animContainer);
        }

        // 0.1 秒后白布淡出
        setTimeout(() => {
          whiteMask.style.opacity = '0';
          setTimeout(() => {
            if (document.body.contains(whiteMask)) {
              document.body.removeChild(whiteMask);
            }
          }, 800);
        }, 100);

      }, 2800); 
    },
    goAgreement() { this.$router.push({ path: '/help', query: { tab: 'agreement' } }) },
    goPrivacy() { this.$router.push({ path: '/help', query: { tab: 'privacy' } }) }
  }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('/bg.webp') no-repeat center center;
  background-size: cover;
  padding: 20px;
  box-sizing: border-box;
}
@media screen and (max-aspect-ratio: 3/2) {
  .login-page {
    background-image: url('/bg-square.webp');
  }
}

.login-page, .login-page * {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
}

.login-box {
  width: 85%; /* 👈 从 90% 缩到 85%，两边留出更多空间 */
  max-width: clamp(300px, 35vw, 420px);
  
  max-height: 85vh; 
  overflow-y: auto;
  box-sizing: border-box;
  
  /* 👈 上下 15px，左右缩到 16px */
  padding: clamp(15px, 2vh, 20px) 16px; 
  
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.65); 
  backdrop-filter: blur(8px); 
  -webkit-backdrop-filter: blur(8px); 
  border: 1px solid rgba(255, 255, 255, 0.5); 
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0,0,0,0.05);
  transform: translateX(-10vw); /* 保持你原本的左偏 */
}

.login-box::-webkit-scrollbar { width: 6px; }
.login-box::-webkit-scrollbar-thumb { background: #dcdfe6; border-radius: 3px; }

.tab-wrap { 
  display: flex; 
  border-bottom: 2px solid #f0f2f5; 
  margin-bottom: 10px; /* 👈 从 12px 缩到 10px */
}
.tab-item { 
  flex: 1; 
  text-align: center; 
  padding: 6px 0; /* 👈 从 8px 缩到 6px */
  color: #666; 
  cursor: pointer; 
  font-size: 14px; 
  position: relative; 
  transition: all 0.2s; 
}
.tab-item.active { color: #d6486b; font-weight: bold; }
.tab-item.active::after { content: ''; position: absolute; bottom: -2px; left: 50%; transform: translateX(-50%); width: 40px; height: 3px; background: #d6486b; border-radius: 2px; }

.form-row { display: flex; gap: 10px; }
.form-item { flex: 1; margin-bottom: 8px; }
label {
  display: block;
  margin-bottom: 4px;
  color: #444;
  /* 👇 字体稍微调小 */
  font-size: clamp(12px, 1.2vw, 13px); 
  font-weight: 500;
}
input {
  width: 100%; 
  height: 32px; 
  border: 1px solid #dcdfe6; 
  border-radius: 8px; 
  padding: 0 10px; /* 👈 内部文字留白也缩小一点 */
  font-size: 12px; 
  background: #f9f9f9; 
  transition: all 0.2s; 
  box-sizing: border-box;
}input:focus { border-color: #409eff; background: #fff; outline: none; box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1); }

.code-input-group { display: flex; gap: 12px; }
.code-input-group input { flex: 1; }
.get-code-btn {
  width: 100px;
  height: 30px !important; 
  border: none;
  border-radius: 8px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px !important; 
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  
  /* 👇 核心：防止在 Flex 布局中被输入框强行拉伸 */
  flex-shrink: 0;
  align-self: center; 
}.get-code-btn:not(:disabled):hover { background: #ffe6ed; }
.get-code-btn:disabled { color: #999; background: #f5f5f5; cursor: not-allowed; }

.forgot-row { text-align: right; margin: -6px 0 12px; }
.forgot-link { color: #409eff; font-size: 13px; cursor: pointer; }
.forgot-link:hover { text-decoration: underline; }

.submit-btn {
  width: 80px; /* 👈 从 110px 缩到 100px */
  height: 32px; /* 👈 从 34px 缩到 32px */
  border-radius: 8px; 
  background: linear-gradient(135deg, #409eff, #1e72d0); 
  color: #fff; 
  border: none; 
  font-size: 13px; /* 👈 字体再小一号 */
  font-weight: 500; 
  cursor: pointer; 
  margin: 10px auto 0; /* 👈 上边距缩小 */
  display: block; 
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3); 
  transition: all 0.3s;
}
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(64, 158, 255, 0.5); }

.agree-row { margin-top: 12px; }
.custom-checkbox { display: flex; align-items: flex-start; cursor: pointer; user-select: none; font-size: 12px; color: #666; }
.custom-checkbox input { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; }
.checkmark { position: relative; height: 18px; width: 18px; background-color: #fff; border: 1px solid #dcdfe6; border-radius: 4px; margin-right: 8px; transition: all 0.2s; flex-shrink: 0; }
.custom-checkbox:hover input ~ .checkmark { border-color: #d6486b; }
.custom-checkbox input:checked ~ .checkmark { background-color: #d6486b; border-color: #d6486b; }
.checkmark:after { content: ""; position: absolute; display: none; }
.custom-checkbox input:checked ~ .checkmark:after { display: block; }
.custom-checkbox .checkmark:after { left: 6px; top: 2px; width: 4px; height: 9px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); }
.agree-text a { color: #d6486b; text-decoration: none; }
.agree-text a:hover { text-decoration: underline; }

.modal-mask {
  position: fixed; inset: 0; background: rgba(0, 0, 0, 0.2); backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px); display: flex; align-items: center; justify-content: center; z-index: 1111; transition: all 0.3s ease; 
}

.reset-modal {
  /* 👇 宽度限制和登录框保持一致 */
  width: 85%; 
  max-width: 360px; 
  max-height: 85vh;
  overflow-y: auto;
  box-sizing: border-box;
  
  /* 👇 内边距和登录框保持完全一致 */
  padding: clamp(15px, 2vh, 20px) 16px; 
  
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.65); 
  backdrop-filter: blur(8px); 
  -webkit-backdrop-filter: blur(8px); 
  border: 1px solid rgba(255, 255, 255, 0.5); 
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0,0,0,0.05);
  
  /* 👇 保持你的左偏效果 */
  transform: translateX(-10vw); 
}
.reset-modal h3 {
  margin: 0 0 12px 0; /* 👈 从 16px 缩到 12px，和 Tab 栏保持一致 */
  text-align: center;
  color: #d6486b;
  font-size: 16px; /* 👈 稍微缩小一点 */
  font-weight: 600;
}

/* 表单行间距 */
.reset-modal .form-row {
  display: flex;
  gap: 10px; /* 👈 和登录页的 input gap 保持 10px */
  margin-bottom: 8px;
}
.reset-modal .form-item {
  flex: 1;
  margin-bottom: 8px; /* 👈 和登录页保持 8px */
}
.reset-modal .form-row .form-item { margin-bottom: 0; }
.reset-modal .form-item label { font-size: 12px; margin-bottom: 4px; }
.reset-modal .code-input-group { display: flex; gap: 12px; }
.reset-modal .code-input-group input { flex: 1; }
.reset-modal .get-code-btn { width: 100px; height: 36px; font-size: 13px; padding: 0; flex-shrink: 0; }
.reset-modal .btn-group { display: flex; justify-content: center; gap: 12px; margin-top: 16px; }
.reset-modal .btn-group button { width: 80px; height: 32px; border-radius: 8px; font-size: 13px; }
.btn-group { display: flex; gap: 12px; margin-top: 24px; }
.confirm-btn { flex: 1; height: 40px; border-radius: 8px; border: none; background: linear-gradient(135deg, #409eff, #1e72d0); color: #fff; font-size: 15px; font-weight: bold; cursor: pointer; box-shadow: 0 4px 10px rgba(64, 158, 255, 0.3); }
.cancel-btn { flex: 1; height: 40px; border-radius: 8px; border: 1px solid #dcdfe6; background: #fff; color: #666; font-size: 15px; cursor: pointer; }

.slider-box {
  background: #fff;
  padding: 20px 16px; /* 👈 和主登录框内边距一致 */
  border-radius: 16px;
  width: 85%; /* 👈 和主登录框宽度一致 */
  max-width: 320px; /* 稍微小一点，因为滑块不需要那么宽 */
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  transform: translateX(-10vw);
}
.slider-box h4 { margin: 0 0 6px 0; color: #333; font-size: 15px; }
.slider-box p { margin: 0 0 16px 0; font-size: 12px; color: #999; }

.slider-track { position: relative; height: 40px; background: #f5f5f5; border-radius: 20px; border: 1px solid #e4e7ed; box-shadow: inset 0 2px 4px rgba(0,0,0,0.05); overflow: hidden; transition: all 0.3s; }
.slider-track.is-success { border-color: #67c23a; background: #f0f9eb; }

.slider-bg-text {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; font-size: 13px; color: #999; z-index: 1; user-select: none; pointer-events: none; background: linear-gradient(90deg, #999 0%, #333 50%, #999 100%); background-size: 200% 100%; -webkit-background-clip: text; -webkit-text-fill-color: transparent; animation: textFlow 2s linear infinite;
}
@keyframes textFlow { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
.slider-track.is-success .slider-bg-text { display: none; }

.slider-fill { position: absolute; left: 0; top: 0; height: 100%; background: #e1f3d8; z-index: 2; transition: width 0.1s; }
.slider-track.is-success .slider-fill { background: #d1edc4; }

.slider-btn {
  position: absolute; 
  top: 0px; 
  left: 0px; 
  width: 40px; /* 👈 和轨道高度一致，保证是正圆 */
  height: 40px; 
  background: transparent; /* 👈 去掉白底 */
  border: none; /* 👈 去掉边框 */
  border-radius: 50%; 
  box-shadow: 0 2px 6px rgba(0,0,0,0.15); /* 保留一点阴影，更有立体感 */
  display: flex; 
  align-items: center; 
  justify-content: center; 
  cursor: grab; 
  z-index: 3; 
  user-select: none; 
  transition: all 0.1s;
}

.slider-btn:active {
  cursor: grabbing;
  transform: scale(0.95); /* 按住的时候微缩 */
}

/* 把原来成功状态的绿色边框去掉，只要印章图片没变就行 */
.slider-track.is-success .slider-btn {
  border: none;
  color: transparent; /* 把里面可能残留的旧文字颜色透明掉 */
}

.form-anim { animation: fadeIn 0.3s ease; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
::v-deep .el-message { z-index: 99999 !important; }

</style>